module.exports = __webpack_public_path__ + "img/icone-cottom.2f4c8691.svg";